import { Component, inject } from '@angular/core';
import { GeneralAccountComponent } from './general-account/general-account.component';
import { ResponsiveBaseComponent, JJamesLoadingComponent, JJamesAlertComponent } from 'shared-lib';
import { TranslatePipe } from '@ngx-translate/core';
import { AccountDetailsService, EditMyAccountRequest, OperatorActionsService, ParkingOperatorDto, ParkingService } from '../../api/gen';

@Component({
  selector: 'app-my-account',
  imports: [GeneralAccountComponent, JJamesLoadingComponent, JJamesAlertComponent, TranslatePipe],
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent extends ResponsiveBaseComponent {

  private service = inject(OperatorActionsService);
  loading: boolean = false;
  errorMessage: string = '';
  accountOperator: ParkingOperatorDto | null = null;
  constructor() {
    super();
  }

  ngOnInit() {
    console.log('MyAccountComponent initialized');
    this.loadAccountDetails();
  }
  loadAccountDetails() {
    this.loading = true;
    this.service.operatorMyAccountGet().subscribe({
      next: (response) => {
        this.accountOperator = response;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error fetching account details:', error);
        this.errorMessage = 'An error occurred while fetching account details.';
        this.loading = false;
      }
    });
  }

  onEditFormSubmitted($event: EditMyAccountRequest) {
    this.loading = true;
    this.service.operatorMyAccountPut($event).subscribe({
      next: (response) => {

        this.accountOperator = response;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error updating account details:', error);
        this.errorMessage = 'An error occurred while updating account details.';
        this.loading = false;
      }
    });
  }
}

